import React from 'react';
import styled from 'styled-components';

/** Contenitore di pagina standard. */
export const PageContainer = styled.div`
  padding: var(--space-lg);
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: var(--space-md);
  }
`;

export const PageContainerWide = styled(PageContainer)`
  max-width: 1400px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-md);
  flex-wrap: wrap;
  margin-bottom: var(--space-xl);
`;

export const PageTitle = styled.h1`
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin: 0;
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);

  svg {
    width: 1.6rem;
    height: 1.6rem;
    color: var(--primary-700);
    flex-shrink: 0;
  }
`;

export const PageSubtitle = styled.p`
  margin: var(--space-xs) 0 0;
  color: var(--text-secondary);
  font-size: var(--font-size-base);
`;

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Icona lucide da affiancare al titolo. */
  icon?: React.ReactNode;
  /** Azioni allineate a destra (bottoni, filtri). */
  actions?: React.ReactNode;
}

/**
 * Intestazione di pagina standard:
 *   <PageHeader title="Ingredienti" subtitle="Gestione materie prime"
 *               icon={<Package />} actions={<Button>Nuovo</Button>} />
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, icon, actions }) => (
  <HeaderRow>
    <div>
      <PageTitle>
        {icon}
        {title}
      </PageTitle>
      {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
    </div>
    {actions && <div style={{ display: 'flex', gap: 'var(--space-sm)', alignItems: 'center', flexWrap: 'wrap' }}>{actions}</div>}
  </HeaderRow>
);

export default PageHeader;
